import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { PolicyTableInner } from './parts';

import { JSX } from 'react';
import styles from './policyTable.module.scss';

export type PolicyTableProps = SliceComponentProps<Content.PolicyTableSlice>;

const PolicyTable = ({ slice }: PolicyTableProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
      className={`${styles.section} ${styles[slice.variation]}`}
    >
      <PolicyTableInner slice={slice} />
    </section>
  );
};

export default PolicyTable;
